<mat-card appearance="raised">
    @if (linqset) {
        <div class="heading-container">
            @for (heading of headings; track heading._key) {
                <mat-card-header>
                    <mat-card-subtitle>{{heading.label}}</mat-card-subtitle>
                    <mat-card-title>{{heading.description}}</mat-card-title>    
                </mat-card-header>
            }
        </div>
    }
    <span style="padding-bottom:15px;"></span>
</mat-card>
